import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkIfhasSetToDisplayOnly, getCountryCode, getModuleCode, getModuleName } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { setBehaviorTreeData } from "../../store/components/MarketExplorer.slice";
import TreeServices from "../../services/Tree.services";
import { deepMergeObjects, generateGUID } from "../../utils/MainHelper.js";
import WorkerServices from "../../services/Worker.services";
import ConfigServices from "../../services/Config.services.js";

function useBehaviorSelectionTreeLoading() {
    const dispatch = useDispatch();
    const [isLoading, setisLoading] = useState(false);
    const [forceRefresh, setForceRefresh] = useState(false);
    const [percentage, setPercentage] = useState(0)
    const {
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);

    const {
        configuration: { selectedTarget }
    } = useSelector((state) => state.marketExplorer);

    const moduleCode = getModuleCode()

    const percentageCallBack = (percent) => { setPercentage(percent) }

    useEffect(() => {
        const getTreeFunction = async () => {

            const countryCode = getCountryCode("enterprise");
            // const marketPackageCode = marketPackage.code.replace("dev", "");
            // const folderLockConfigSpecific = selectedTarget?.lockFolder?.[marketPackageCode]?.[countryCode];
            // const folderLockConfigAll = selectedTarget?.lockFolder?.[marketPackageCode]?.allcountry;
            // const moduleConfig = deepMergeObjects(folderLockConfigAll || {}, folderLockConfigSpecific || {});
            // const folderLockConfigAllCountry = moduleConfig?.allcountry;
            // const folderLockConfigSpecificCountry = moduleConfig?.[countryCode];
            // let folderLockConfig = deepMergeObjects(moduleConfig || {}, deepMergeObjects(folderLockConfigAllCountry || {}, folderLockConfigSpecificCountry || {}));

            const folderLockConfig = await ConfigServices.getFolderLockConfig({ module: getModuleName(), marketExplorerCode: selectedTarget?.code });
            if (["mokb_marketexplorer", "mokb_marketexplorer_main"].includes(selectedTarget.code)) {
                setisLoading(true);
                TreeServices.getBehavioralAttributes(undefined, selectedTarget, percentageCallBack).then(async (response) => {
                    let filtered = await checkIfhasSetToDisplayOnly(response, selectedTarget.code, selectedTarget)
                    if (filtered.length && (["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode) && ["mokb_marketexplorer", "mokb_marketexplorer_main"].includes(selectedTarget.code))) {
                        filtered = filtered.map((parentItem) => {
                            if (parentItem.children && parentItem.children.length) {
                                // const microsegmentDetails = { ...(parentItem?.children?.[0]?.microsegmentDetails || {}) }
                                // if (Object.keys(microsegmentDetails).length) {
                                //     const fullPathArray = microsegmentDetails.fullPath.split("\\");
                                //     const fullPathNewArray = fullPathArray.slice(0, -1);
                                //     const fullPath = fullPathNewArray.join("\\");
                                //     microsegmentDetails.fullPath = fullPath

                                //     parentItem.children = parentItem.children.concat([{
                                //         isElement: "mokb",
                                //         checkable: false,
                                //         selectable: false,
                                //         key: generateGUID(),
                                //         microsegmentDetails
                                //     }])
                                // }
                            }
                            return parentItem
                        })
                    }
                    dispatch(setBehaviorTreeData(filtered));
                    setisLoading(false);
                });
            } else if (["hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "icd10", "expertmedia"].includes(marketPackage.code.replace("dev", ""))) {
                setisLoading(true);
                TreeServices.getBehavioralAttributes(undefined, undefined, percentageCallBack).then(async (response) => {
                    const find = response.find((child) => child.name === "Knowledge Base");
                    let tempDataHolder = null;
                    if (find) {
                        tempDataHolder = find.children || find.tempChildren;
                    } else { tempDataHolder = response; }

                    const filtered = await checkIfhasSetToDisplayOnly(tempDataHolder, selectedTarget.code, selectedTarget)
                    dispatch(setBehaviorTreeData(filtered));
                    setisLoading(false);
                });
            } else if (["whitespaces"].includes(marketPackage?.parent?.oiCode)) {
                setisLoading(true);
                const treeCode = selectedTarget.code.split("_")[1];
                TreeServices.getWhiteSpaceTree(undefined, selectedTarget, percentageCallBack).then(async (response) => {
                    if (folderLockConfig) {
                        WorkerServices.lockFolderBaseFromConfig([response, folderLockConfig]).then(async (lockedFolder) => {
                            const filtered = await checkIfhasSetToDisplayOnly(lockedFolder, treeCode, selectedTarget)
                            dispatch(setBehaviorTreeData(filtered));
                            setisLoading(false);
                        });
                    } else {
                        const filtered = await checkIfhasSetToDisplayOnly(response, treeCode, selectedTarget)
                        dispatch(setBehaviorTreeData(filtered));
                        setisLoading(false);
                    }
                });
            } else if (marketPackage?.parent?.oiCode !== "pharma") {
                setisLoading(true);
                let prm = null;
                if (selectedTarget.code === "behaviorConsumer") {
                    prm = TreeServices.getAudienceTree(false, {
                        key: selectedTarget.code,
                        ...selectedTarget
                    }, percentageCallBack).then((response) => WorkerServices.lockFolderBaseFromConfig([response, {
                        current: {
                            hideAllKeywords: true
                        }
                    }]));
                } else if (selectedTarget.code === "fbsensors") {
                    prm = TreeServices.getBehavioralAttributesFromOutSide("OI - AI Tag.folder", "OpenWeb")
                        .then((response) => WorkerServices.lockFolderBaseFromConfig([response, {
                            current: {
                                hideAllKeywords: true
                            }
                        }]));
                } else if (selectedTarget.code === "ccsaudiences") {
                    prm = TreeServices.getBehavioralAttributesFromOutSide("OI - Brand and Insights.folder", "Custom Taxonomy")
                        .then((response) => WorkerServices.lockFolderBaseFromConfig([response, {
                            current: {
                                hideAllKeywords: true
                            }
                        }]));
                } else if (marketPackage?.code?.replace("dev", "") === "facebookaudiences" && countryCode === "vn") {
                    prm = TreeServices.getBehavioralAttributes(undefined, undefined, percentageCallBack)
                        .then((response) => WorkerServices.lockFolderBaseFromConfig([response, {
                            current: {
                                hideAllKeywords: true
                            }
                        }]));
                } else {
                    prm = TreeServices.getBehavioralAttributes(undefined, selectedTarget, percentageCallBack).then((response) => {
                        if (["verticalpackages", "seasonalpackages"].includes(selectedTarget?.code)) {
                            const found = response.find((d) => d.name === selectedTarget.text);
                            if (found) {
                                return WorkerServices.lockFolderBaseFromConfig([found.children, {
                                    current: {
                                        hideAllKeywords: true
                                    }
                                }]);
                            }
                        }
                        return response;
                    });
                }
                prm.then(async (response) => {
                    if (folderLockConfig) {
                        WorkerServices.lockFolderBaseFromConfig([response, folderLockConfig]).then(async (lockedFolder) => {
                            const filtered = await checkIfhasSetToDisplayOnly(lockedFolder, selectedTarget.code, selectedTarget)
                            dispatch(setBehaviorTreeData(filtered));
                            setisLoading(false);
                        });
                    } else {
                        const filtered = await checkIfhasSetToDisplayOnly(response, selectedTarget.code, selectedTarget)
                        dispatch(setBehaviorTreeData(filtered));
                        setisLoading(false);
                    }
                });
            }
        }
        getTreeFunction()
    }, [marketPackage, selectedTarget, forceRefresh]);

    return {
        isLoading,
        percentage,
        forceRefresh,
        setForceRefresh
    };
}

export default useBehaviorSelectionTreeLoading;
